var typography = {
  fontFamily: ['Fellix', '-apple-system', 'BlinkMacSystemFont', 'Helvetica Neue', 'Arial', 'sans-serif'].join(', '),
  variants: {
    displayXL: {
      fontSize: '48px',
      lineHeight: '56px',
      fontWeight: 700
    },
    displayXL2: {
      fontSize: '48px',
      lineHeight: '56px',
      fontWeight: 300
    },
    displayL: {
      fontSize: '40px',
      lineHeight: '48px',
      fontWeight: 700
    },
    displayL2: {
      fontSize: '40px',
      lineHeight: '48px',
      fontWeight: 300
    },
    displayM: {
      fontSize: '32px',
      lineHeight: '34px',
      fontWeight: 700
    },
    displayM2: {
      fontSize: '32px',
      lineHeight: '34px',
      fontWeight: 300
    },
    displayS: {
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 700
    },
    displayS2: {
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 300
    },
    heading: {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 700
    },
    heading2: {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 300
    },
    subheading: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600
    },
    subheading2: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400
    },
    body: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500
    },
    body2: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400
    },
    caption: {
      fontSize: '12px',
      lineHeight: '14px',
      fontWeight: 500
    },
    caption2: {
      fontSize: '12px',
      lineHeight: '14px',
      fontWeight: 400
    },
    overline: {
      fontSize: '10px',
      lineHeight: '12px',
      fontWeight: 500
    },
    overline2: {
      fontSize: '10px',
      lineHeight: '12px',
      fontWeight: 400
    }
  }
};
export default typography;